export async function fetchPayments(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/fetch-payment/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function checkPaymentStatus(milestoneId, referenceNumber) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API +
      `/v1/api/fetch-payment-status/${milestoneId}/${referenceNumber}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}
